import { Component, computed, input } from '@angular/core';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { TooltipDirective, TooltipType } from '@cumlaude/shared-components-overlays';
import { delay, of } from 'rxjs';
import { CssSpinnerComponent } from '../../../layout/css-spinner/css-spinner.component';
import { AsyncPipe } from '@angular/common';

export interface MatrixCell {
	value?: number; // percentage waarde (optioneel voor disabled cellen)
	displayValue?: string; // optionele display string, anders wordt value + '%' gebruikt
	disabled?: boolean; // voor lege/uitgeschakelde cellen
	voorlopig?: boolean;
	tooltip?: TooltipType;
}

export interface MatrixData {
	columnHeaders: string[];
	columnClasses: string[];
	rowHeaders: string[];
	cells: MatrixCell[][]; // [rij][kolom]
}

@Component({
	selector: 'app-aanwezigheid-matrix',
	templateUrl: './aanwezigheid-matrix.component.html',
	styleUrls: ['./aanwezigheid-matrix.component.scss'],
	imports: [IconComponent, TooltipDirective, CssSpinnerComponent, AsyncPipe],
})
export class AanwezigheidMatrixComponent {
	readonly data = input<MatrixData>();

	readonly loading = input(false);

	/**
	 * Bepaalt de CSS class voor een cel gebaseerd op de waarde
	 */
	getCellClass(cell: MatrixCell): string {
		return `${this.getColorClass(cell)}${cell.voorlopig ? ' striped-s' : ''}`;
	}

	getColorClass(cell: MatrixCell): string {
		if (cell.disabled || cell.value === undefined) {
			return 'onbekend'; // grijs
		}

		if (cell.value >= 95) {
			return 'goede-aanwezigheid'; // groen
		} else if (cell.value >= 94) {
			return 'beginnend-verzuim-3'; // geel 30%
		} else if (cell.value >= 92) {
			return 'beginnend-verzuim-2'; // geel 50%
		} else if (cell.value > 90) {
			return 'beginnend-verzuim'; // geel
		} else if (cell.value > 85) {
			return 'aanhoudend-verzuim-3'; // rood 30%
		} else if (cell.value > 80) {
			return 'aanhoudend-verzuim-2'; // rood 50%
		} else {
			return 'aanhoudend-verzuim'; // rood
		}
	}

	getCellDisplayValue(cell: MatrixCell): string {
		if (cell.disabled) return '';

		return cell.displayValue ?? cell.value?.toString() ?? '';
	}

	readonly gridStyle = computed(() => ({
		'grid-template-columns': `auto repeat(${this.data()?.columnHeaders.length ?? 0}, 1fr)`,
		'grid-template-rows': `auto repeat(${this.data()?.cells.length ?? 0}, 1fr)`,
	}));

	spinnerDelay = of(true).pipe(delay(200));
}
